import { CASE_CREATION_PATH } from 'app/app.routes';

export interface NavigationEntry {
  label: string;
  path: string;
}

export interface NavigationMenu {
  id: string;
  label: string;
  entries: NavigationEntry[];
}

export const NAVIGATION: NavigationMenu[] = [
  {
    id: 'cases',
    label: 'Cases',
    entries: [{ label: 'Case anlegen', path: `/${CASE_CREATION_PATH}` }],
  },
];
